export const paperPlatesHeroContent = {
  badge: 'Eco-Friendly Food Service',
  scriptTitle: 'Our Sustainable',
  mainTitleLines: ['Paper', 'Plates'],
  kicker: 'Strong, Clean & Responsibly Made',
  descriptions: [
    'We are dedicated to producing sustainable, high-quality paper plates for every occasion, combining strength, clean presentation, and responsibly sourced materials for greener everyday meals.',
    'From picnics and catering events to celebrations and takeaway service, our paper plates deliver convenience and durability without compromising food-safe performance across India.',
  ],
  features: [
    'Oil Resistant',
    'Food Grade Safe',
    'Eco-Friendly',
    'Pan India Supply',
  ],
  imagePrimary: {
    src: '/images/products/Paper-Plates1 (3).png',
    alt: 'Premium biodegradable paper plates layout',
  },
  imageSecondary: {
    src: '/images/products/Paper-Plates1 (2).png',
    alt: 'Eco-friendly paper material for plate manufacturing',
  },
  stampLabel: 'Food Grade',
};

export const paperPlatesSpecs = {
  businessType: {
    label: "Business Type",
    value: "Manufacturer, Exporter, Supplier, Wholesaler",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
      </svg>
    ),
  },
  location: {
    label: "Buyer Preferred Location",
    value: "Pan India Supply + Export",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
        <circle cx="12" cy="10" r="3" />
      </svg>
    ),
  },
  type: {
    label: "Type",
    value: "Paper Plates",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <circle cx="12" cy="12" r="4" />
      </svg>
    ),
  },
  color: {
    label: "Color",
    value: "White / Natural Kraft / Custom Printed",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" />
        <path d="M7.5 10.5C8.32843 10.5 9 9.82843 9 9C9 8.17157 8.32843 7.5 7.5 7.5C6.67157 7.5 6 8.17157 6 9C6 9.82843 6.67157 10.5 7.5 10.5Z" />
        <path d="M11.5 7.5C12.3284 7.5 13 6.82843 13 6C13 5.17157 12.3284 4.5 11.5 4.5C10.6716 4.5 10 5.17157 10 6C10 6.82843 10.6716 7.5 11.5 7.5Z" />
        <path d="M16.5 10.5C17.3284 10.5 18 9.82843 18 9C18 8.17157 17.3284 7.5 16.5 7.5C15.6716 7.5 15 8.17157 15 9C15 9.82843 15.6716 10.5 16.5 10.5Z" />
        <path d="M6 14C6 14 7.5 19 12 19C16.5 19 18 14 18 14" />
      </svg>
    ),
  },
  coating: {
    label: "Coating",
    value: "Food-Safe Bio-Coating / PE Coated (Optional)",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2L2 7l10 5 10-5-10-5z" />
        <path d="M2 17l10 5 10-5" />
        <path d="M2 12l10 5 10-5" />
      </svg>
    ),
  },
  material: {
    label: "Material",
    value: "Multi-Layer Recycled Fiber / Food Grade Paper Board",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z" />
      </svg>
    ),
  },
  gsm: {
    label: "GSM",
    value: "80 - 300 GSM",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 7V4h16v3" />
        <path d="M9 20h6" />
        <path d="M12 4v16" />
      </svg>
    ),
  },
  usage: {
    label: "Usage",
    value: "Dinnerware, Events, Catering, Takeaway Food Service",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" />
        <path d="M7 2v20" />
        <path d="M21 15V2v0" />
        <path d="M21 15v7a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-7" />
        <path d="M17 15v-3" />
      </svg>
    ),
  },
  thickness: {
    label: "Thickness",
    value: "As per requirement",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <circle cx="12" cy="12" r="6" />
        <circle cx="12" cy="12" r="2" />
      </svg>
    ),
  },
  feature: {
    label: "Feature",
    value: "Greaseproof, Leak Resistant, Compostable, Microwave Safe",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
    ),
  },
  industrialUse: {
    label: "Industrial Use",
    value: "Plate Making, Die Cutting & Food Service Packaging",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="2" width="20" height="8" rx="2" />
        <rect x="2" y="14" width="20" height="8" rx="2" />
        <line x1="6" y1="10" x2="6" y2="14" />
        <line x1="18" y1="10" x2="18" y2="14" />
      </svg>
    ),
  },
  sizes: {
    label: "Sizes",
    value: "As per requirement",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="21 8 21 21 8 21" />
        <rect x="3" y="3" width="14" height="14" rx="2" ry="2" />
      </svg>
    ),
  },
};

export const paperPlatesBenefits = [
  {
    title: "Heavy-Duty Strength",
    description: "Multi-layer fiber construction provides excellent rigidity and load-bearing capacity for hot and oily foods without bending or leaking.",
  },
  {
    title: "Eco-Friendly & Compostable",
    description: "Made from biodegradable materials that offer a sustainable alternative to plastic plates for environmentally conscious businesses.",
  },
  {
    title: "Food Grade Safe",
    description: "Food-safe bio-coating ensures hygienic serving for restaurants, caterers, and event organizers with certified quality standards.",
  },
  {
    title: "Cost Effective",
    description: "Bulk manufacturing and efficient material usage help reduce per-unit costs for high-volume food service and hospitality operations.",
  },
];
